import { Injectable, signal, EventEmitter } from '@angular/core';
import { IKart, IKartTuru, IIcerik, IVT, IYollar } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { IParametreSetiGrubu } from '@/src/service/fikoyt-ui/interfaces/IParametreSeti.interface';
import { ISablon } from '@/src/service/fikoyt-ui/src/lib/paylasim-sistemi/sablon-editoru/sablon.interface';
import { FikoYTId } from '@/src/service/fikoyt-ui/helpers/FikoYTId';
import { personelAcilirKutu, musteriAcilirKutu, firmaAcilirKutu, TR_RX_FN } from './hmi-ortak-helpers';

@Injectable({ providedIn: 'root' })
export class HmiProjelerService {
  paylasimYapildi = new EventEmitter<any>(true);
  aktifIcerikNo = 0;

  kart: IKart = {
    _id: new FikoYTId().toString(),
    vt: 'FikoYT.sistem.hareketler' as IVT,
    yol: 'FikoYT.sistem.hareketler.kalem' as IYollar,
    turu: IKartTuru.KART,
    gizlilik: 'Herkese Açık',
    kisiler: [],
    veri: {
      solSimge: { aciklama: undefined, baslik: 'HMI', renkArka: '#0ea5e9', renkYazi: '#fff' },
      kurdela: { aciklama: undefined, baslik: 'HMI', renkArka: undefined, renkYazi: undefined },
      icerikler: [
        { _id: new FikoYTId().toString(), html: '', aciklama: '', sifre: null } as IIcerik,
      ],
    },
  };

  readonly parametreSetleri: IParametreSetiGrubu[] = [
    {
      id: 'hmi.proje',
      baslik: 'Projeler',
      simge: '📁',
      aciklama: 'Proje oluştur ve takip et',
      renk: 'linear-gradient(135deg, #7c2d12, #fa8c16)',
      kaynak: 'kod',
      bilesen: 'projeler',
      altGruplar: [
        {
          id: 'hmi.proje.kategori',
          baslik: 'Kategori',
          simge: '📂',
          aciklama: 'Proje kategorisi tanımla',
          parametreler: [
            { turu: 'Yazı', ismi: 'kategoriAdi', baslik: 'Kategori Adı', ayarlar: { zorunlu: true } },
            { turu: 'Renk', ismi: 'renk', baslik: 'Renk' },
            { turu: 'Açılır Kutu', ismi: 'oncelik', baslik: 'Öncelik', ayarlar: { secenekler: ['Düşük', 'Normal', 'Yüksek', 'Kritik'] } },
          ],
          sablon: {
            genislik: 520, yukseklik: 200, mod: 'serbest',
            arkaPlan: { tur: 'gradient', deger: 'linear-gradient(135deg, #134e5e, #2d6a4f, #52b788)' },
            bolgeler: [],
            elementler: [
              { id: 'k0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 520, yukseklik: 6, stil: { fill: 'rgba(255,255,255,0.15)' } },
              { id: 'k1', tur: 'sabit-metin', icerik: '📂', x: 5, y: 15, genislik: 60, yukseklik: 60, stil: { fontSize: 40, textAlign: 'center', verticalAlign: 'center' } },
              { id: 'k2', tur: 'parametre-metin', parametreAnahtari: 'kategoriAdi', x: 16, y: 12, genislik: 350, yukseklik: 40, stil: { fontSize: 24, fontWeight: '700', color: '#ffffff', verticalAlign: 'center' } },
              { id: 'k3', tur: 'sekil', sekilTuru: 'dikdortgen', x: 16, y: 55, genislik: 110, yukseklik: 28, stil: { fill: 'rgba(0,0,0,0.25)', borderRadius: 14 } },
              { id: 'k4', tur: 'parametre-render', parametreAnahtari: 'oncelik', x: 16, y: 55, genislik: 110, yukseklik: 28, stil: { fontSize: 11, fontWeight: '600', color: '#a7f3d0', textAlign: 'center', verticalAlign: 'center', letterSpacing: 1 } },
              { id: 'k5', tur: 'sekil', sekilTuru: 'daire', x: 85, y: 55, genislik: 28, yukseklik: 28, stil: { fill: '#ffffff', opacity: 0.3 } },
              { id: 'k6', tur: 'parametre-render', parametreAnahtari: 'renk', x: 85, y: 55, genislik: 28, yukseklik: 28, stil: { fontSize: 11, textAlign: 'center', verticalAlign: 'center' } },
              { id: 'k7', tur: 'sekil', sekilTuru: 'dikdortgen', x: 5, y: 88, genislik: 80, yukseklik: 2, stil: { fill: 'rgba(255,255,255,0.2)' } },
              { id: 'k8', tur: 'sabit-metin', icerik: 'KATEGORİ', x: 5, y: 90, genislik: 100, yukseklik: 16, stil: { fontSize: 8, fontWeight: '700', color: 'rgba(255,255,255,0.35)', letterSpacing: 3 } },
            ],
          } as ISablon,
          altKartSablonlari: [
            {
              id: 'hmi.proje.guncelleme',
              baslik: 'Güncelleme',
              simge: '🔄',
              parametreler: [
                { turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', ayarlar: { zorunlu: true, secenekler: ['Devam Ediyor', 'Tamamlandı', 'Beklemede', 'İptal'] } },
                { turu: 'Sayı', ismi: 'ilerleme', baslik: 'İlerleme %', ayarlar: { min: 0, maks: 100 } },
              ],
              sablon: {
                genislik: 520, yukseklik: 220, mod: 'serbest',
                arkaPlan: { tur: 'gradient', deger: 'linear-gradient(160deg, #0d1b2a 0%, #1b2838 40%, #1a3a4a 100%)' },
                bolgeler: [],
                elementler: [
                  { id: 'g0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 6, yukseklik: 220, stil: { fill: '#58a6ff' } },
                  { id: 'g1', tur: 'sabit-metin', icerik: '🔄', x: 4, y: 8, genislik: 44, yukseklik: 44, stil: { fontSize: 28, textAlign: 'center', verticalAlign: 'center' } },
                  { id: 'g2', tur: 'sabit-metin', icerik: 'GÜNCELLEME', x: 14, y: 8, genislik: 180, yukseklik: 20, stil: { fontSize: 10, fontWeight: '700', color: '#58a6ff', letterSpacing: 3, verticalAlign: 'center' } },
                  { id: 'g3a', tur: 'sekil', sekilTuru: 'dikdortgen', x: 15, y: 35, genislik: 200, yukseklik: 36, stil: { fill: 'rgba(88,166,255,0.12)', borderRadius: 18 } },
                  { id: 'g3', tur: 'parametre-render', parametreAnahtari: 'durum', x: 15, y: 35, genislik: 200, yukseklik: 36, stil: { fontSize: 16, fontWeight: '700', color: '#ffffff', textAlign: 'center', verticalAlign: 'center' } },
                  { id: 'g4', tur: 'parametre-render', parametreAnahtari: 'ilerleme', x: 60, y: 35, genislik: 120, yukseklik: 50, stil: { fontSize: 42, fontWeight: '900', color: '#3fb950', textAlign: 'center', verticalAlign: 'center' } },
                  { id: 'g5', tur: 'sabit-metin', icerik: '%', x: 82, y: 38, genislik: 30, yukseklik: 24, stil: { fontSize: 18, fontWeight: '600', color: '#3fb950', verticalAlign: 'center' } },
                  { id: 'g6', tur: 'sekil', sekilTuru: 'dikdortgen', x: 4, y: 80, genislik: 460, yukseklik: 6, stil: { fill: 'rgba(255,255,255,0.06)', borderRadius: 3 } },
                  { id: 'g7', tur: 'sekil', sekilTuru: 'dikdortgen', x: 4, y: 80, genislik: 230, yukseklik: 6, stil: { fill: '#3fb950', borderRadius: 3 } },
                  { id: 'g8', tur: 'sabit-metin', icerik: 'İLERLEME DURUMU', x: 4, y: 92, genislik: 150, yukseklik: 14, stil: { fontSize: 7, fontWeight: '600', color: 'rgba(255,255,255,0.25)', letterSpacing: 2 } },
                ],
              } as ISablon,
            },
            { id: 'hmi.proje.gorev', baslik: 'Görev', simge: '📋', bilesen: 'proje-gorev' },
            { id: 'hmi.proje.not', baslik: 'Not', simge: '📝', bilesen: 'proje-notu' },

            {
              id: 'hmi.proje.rapor',
              baslik: 'Rapor',
              simge: '📊',
              parametreler: [
                { turu: 'Yazı', ismi: 'raporBaslik', baslik: 'Rapor Başlığı', ayarlar: { zorunlu: true } },
                { turu: 'Yazı Alanı', ismi: 'ozet', baslik: 'Özet' },
              ],
              sablon: {
                genislik: 520, yukseklik: 240, mod: 'serbest',
                arkaPlan: { tur: 'gradient', deger: 'linear-gradient(135deg, #1a1a2e 0%, #2d1b4e 50%, #4a1942 100%)' },
                bolgeler: [],
                elementler: [
                  { id: 'r0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 520, yukseklik: 4, stil: { fill: 'linear-gradient(90deg, #7b2ff7, #c850c0, #ff2d95)' } },
                  { id: 'r1', tur: 'sabit-metin', icerik: '📊', x: 5, y: 10, genislik: 56, yukseklik: 56, stil: { fontSize: 36, textAlign: 'center', verticalAlign: 'center' } },
                  { id: 'r2', tur: 'sabit-metin', icerik: 'RAPOR', x: 5, y: 40, genislik: 56, yukseklik: 16, stil: { fontSize: 8, fontWeight: '700', color: '#c850c0', textAlign: 'center', letterSpacing: 2 } },
                  { id: 'r3', tur: 'parametre-metin', parametreAnahtari: 'raporBaslik', x: 18, y: 10, genislik: 380, yukseklik: 48, stil: { fontSize: 22, fontWeight: '700', color: '#ffffff', verticalAlign: 'center' } },
                  { id: 'r5', tur: 'sekil', sekilTuru: 'dikdortgen', x: 18, y: 48, genislik: 60, yukseklik: 2, stil: { fill: '#c850c0', opacity: 0.5 } },
                  { id: 'r4', tur: 'parametre-metin', parametreAnahtari: 'ozet', x: 5, y: 55, genislik: 480, yukseklik: 80, stil: { fontSize: 13, color: '#b8a9c9', lineHeight: 1.7 } },
                  { id: 'r6', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 94, genislik: 520, yukseklik: 18, stil: { fill: 'rgba(0,0,0,0.2)' } },
                  { id: 'r7', tur: 'sabit-metin', icerik: '◆ PROJE RAPORU', x: 3, y: 94, genislik: 200, yukseklik: 18, stil: { fontSize: 8, fontWeight: '600', color: 'rgba(200,80,192,0.5)', verticalAlign: 'center', letterSpacing: 2 } },
                ],
              } as ISablon,
            },
          ],
        },
        {
          id: 'hmi.proje.ekle',
          baslik: 'Ekle',
          simge: '➕',
          aciklama: 'Yeni proje oluştur',
          parametreler: [
            { turu: 'Otomatik Kod', ismi: 'projeKodu', baslik: 'Proje Kodu', ayarlar: { kodFormat: '{PREFIX}-{YIL}-{AY}-{SAYI:3}', kodPrefix: 'PRJ' } },
            { turu: 'Yazı', ismi: 'projeAdi', baslik: 'Proje Adı', ayarlar: { zorunlu: true } },
            { turu: 'Resim', ismi: 'projeResmi', baslik: 'Proje Resmi' },
            personelAcilirKutu('sorumlu', 'Sorumlu Personel'),
            {
              turu: 'Açılır Kutu', ismi: 'mailHesap', baslik: 'Mail Hesabı', ayarlar: {
                arama: true, silme: true, solSimge: '📬',
                itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: false, resimGoster: false },
                secenekItm: `return { value: scnk._id, label: scnk.email ?? scnk._id, simge: '📬' }`,
                fapiAyarlar: {
                  vt: 'FikoYT.sistem.mail.hesaplar',
                  pipeFunc: `
                  var firmaId = '';
                  try { firmaId = JSON.parse(localStorage.getItem('hmi-pano-ayarlar') || '{}').firmaId || ''; } catch(e) {}
                  var f = { "aktif": { "$ne": false }, "silindi": { "$ne": true } };
                  if (firmaId) f.firmaId = firmaId;
                  if (deger) f.email = { "$regex": deger, "$options": "i" };
                  return [ { "$match": f }, { "$limit": 20 }, { "$project": { _id: 1, "email": 1 } } ]`,
                },
              }
            },
            {
              turu: 'Açılır Kutu', ismi: 'mailRef', baslik: 'İlgili Mail', ayarlar: {
                arama: true, silme: true, solSimge: '📧',
                itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: true, resimGoster: false },
                secenekItm: `
                let p = scnk.veri ?? {};
                let ekSayi = scnk.dosyaSayisi ?? 0;
                let yanitMi = !!p.inReplyTo;
                let simge = yanitMi ? '↩️' : ekSayi > 0 ? '📎' : '📧';
                let tarih = scnk.tarih ? new Date(scnk.tarih).toLocaleDateString('tr-TR', {day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit'}) : '';
                let parcalar = [];
                if (p.kimden) parcalar.push(p.kimden);
                if (p.kime) parcalar.push('→ ' + p.kime);
                if (tarih) parcalar.push(tarih);
                if (ekSayi > 0) parcalar.push(ekSayi + ' ek');
                return { value: scnk._id, label: (p.konu ?? p.kimden ?? scnk._id), simge: simge, aciklama: parcalar.join(' · ') }
              `,
                baglantiModu: 'modal',
                fapiAyarlar: {
                  vt: 'FikoYT.sistem.mail.mesajlar',
                  pipeFunc: `
                  var hesapId = form.find(function(p) { return p.ismi === 'mailHesap' })?.degeri;
                  if (!hesapId) return [ { "$limit": 0 } ];
                  var trMap = {i:'[iİ]',İ:'[iİ]',ı:'[ıI]',I:'[ıI]',ş:'[şŞ]',Ş:'[şŞ]',ç:'[çÇ]',Ç:'[çÇ]',ö:'[öÖ]',Ö:'[öÖ]',ü:'[üÜ]',Ü:'[üÜ]',ğ:'[ğĞ]',Ğ:'[ğĞ]'};
                  var rx = deger ? Array.from(deger).map(function(c){ return trMap[c] || c }).join('') : '';
                  var m = { "sahip": hesapId, "silindi": { "$ne": true } };
                  if (rx) { var rd = { "$regex": rx, "$options": "i" }; m["$or"] = [
                    { "veri.konu": rd },
                    { "veri.kimden": rd },
                    { "veri.kime": rd },
                    { "icerikler.html": rd },
                    { "icerikler.aciklama": rd },
                    { "dosyalar.ismi": rd }
                  ] }
                  return [
                    { "$match": m },
                    { "$sort": { _id: -1 } },
                    { "$limit": 15 },
                    { "$project": { _id: 1, "veri.konu": 1, "veri.kimden": 1, "veri.kime": 1, "veri.inReplyTo": 1, "tarih": 1, "dosyaSayisi": { "$cond": [{ "$isArray": "$dosyalar" }, { "$size": "$dosyalar" }, 0] } } }
                  ]`,
                },
              }
            },
            { turu: 'XYZ', ismi: 'olculer', baslik: 'Ölçüler (mm)', degeri: { x: 0, y: 0, z: 0 }, ayarlar: { adim: 0.0001 } },
            { turu: 'Sayı', ismi: 'agirlik', baslik: 'Ağırlık (kg)', ayarlar: { min: 0, adim: 0.001 } },
            { turu: 'Sayı', ismi: 'ozkulte', baslik: 'Özkütle (g/cm³)', ayarlar: { min: 0, adim: 0.0001 } },
            {
              turu: 'Açılır Kutu', ismi: 'malzeme', baslik: 'Malzeme', ayarlar: {
                secenekler: [
                  { label: 'Çelik', value: 'Çelik' },
                  { label: 'Alüminyum', value: 'Alüminyum' },
                  { label: 'Pirinç', value: 'Pirinç' },
                  { label: 'Dökme Demir', value: 'Dökme Demir' },
                  { label: 'Paslanmaz', value: 'Paslanmaz' },
                  { label: 'Bakır', value: 'Bakır' },
                  { label: 'Plastik', value: 'Plastik' },
                ],
              }
            },
            { turu: 'Yazı Alanı', ismi: 'aciklama', baslik: 'Açıklama' },
            { turu: 'Tarih', ismi: 'baslangic', baslik: 'Başlangıç Tarihi' },
            { turu: 'Tarih', ismi: 'bitis', baslik: 'Bitiş Tarihi' },
          ],
          sayfaKurallari: { yeniSayfaEngelle: true },
          sablon: {
            genislik: 520, yukseklik: 260, mod: 'serbest',
            arkaPlan: { tur: 'gradient', deger: 'linear-gradient(145deg, #0a1628 0%, #1e3a5f 60%, #2563eb 100%)' },
            bolgeler: [],
            elementler: [
              { id: 's0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 520, yukseklik: 4, stil: { fill: 'rgba(59,130,246,0.6)' } },
              { id: 's9', tur: 'sekil', sekilTuru: 'daire', x: 76, y: 4, genislik: 110, yukseklik: 110, stil: { fill: 'rgba(255,255,255,0.06)', stroke: 'rgba(96,165,250,0.3)', strokeWidth: 3 }, katman: 10 },
              { id: 's10', tur: 'parametre-render', parametreAnahtari: 'projeResmi', x: 76, y: 4, genislik: 110, yukseklik: 110, stil: { borderRadius: 55, shadow: '0 4px 20px rgba(0,0,0,0.4)' }, katman: 11 },
              { id: 's1', tur: 'sabit-metin', icerik: '📁', x: 5, y: 8, genislik: 56, yukseklik: 56, stil: { fontSize: 36, textAlign: 'center', verticalAlign: 'center' } },
              { id: 's1a', tur: 'parametre-render', parametreAnahtari: 'projeKodu', x: 16, y: 8, genislik: 160, yukseklik: 18, stil: { fontSize: 9, fontWeight: '700', color: 'rgba(96,165,250,0.7)', letterSpacing: 2, verticalAlign: 'center' } },
              { id: 's2', tur: 'parametre-metin', parametreAnahtari: 'projeAdi', x: 16, y: 20, genislik: 400, yukseklik: 40, stil: { fontSize: 24, fontWeight: '700', color: '#ffffff', verticalAlign: 'center' } },
              { id: 's3', tur: 'parametre-metin', parametreAnahtari: 'aciklama', x: 5, y: 46, genislik: 480, yukseklik: 50, stil: { fontSize: 13, color: '#94a3b8', lineHeight: 1.6 } },
              { id: 's8', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 78, genislik: 520, yukseklik: 58, stil: { fill: 'rgba(0,0,0,0.25)' } },
              { id: 's4', tur: 'sabit-metin', icerik: 'BAŞLANGIÇ', x: 5, y: 80, genislik: 100, yukseklik: 14, stil: { fontSize: 7, fontWeight: '700', color: 'rgba(255,200,0,0.5)', letterSpacing: 2 } },
              { id: 's5', tur: 'parametre-render', parametreAnahtari: 'baslangic', x: 5, y: 88, genislik: 140, yukseklik: 24, stil: { fontSize: 14, fontWeight: '600', color: '#ffc800', verticalAlign: 'center' } },
              { id: 's6', tur: 'sabit-metin', icerik: '→', x: 38, y: 88, genislik: 30, yukseklik: 24, stil: { fontSize: 16, color: 'rgba(255,255,255,0.3)', textAlign: 'center', verticalAlign: 'center' } },
              { id: 's4b', tur: 'sabit-metin', icerik: 'BİTİŞ', x: 48, y: 80, genislik: 100, yukseklik: 14, stil: { fontSize: 7, fontWeight: '700', color: 'rgba(255,200,0,0.5)', letterSpacing: 2 } },
              { id: 's7', tur: 'parametre-render', parametreAnahtari: 'bitis', x: 48, y: 88, genislik: 140, yukseklik: 24, stil: { fontSize: 14, fontWeight: '600', color: '#ffc800', verticalAlign: 'center' } },
            ],
          } as ISablon,
        },
      ],
    },
    {
      id: 'hmi.basit-not',
      baslik: 'Basit Not',
      simge: '📋',
      aciklama: 'Hızlı not ve hatırlatma',
      renk: 'linear-gradient(135deg, #064e3b, #52c41a)',
      kaynak: 'kod',
      bilesen: 'basit-not',
      parametreler: [
        { turu: 'Yazı', ismi: 'baslik', baslik: 'Not Başlığı' },
        { turu: 'Açılır Kutu', ismi: 'kategori', baslik: 'Kategori', ayarlar: { secenekler: ['Genel', 'Acil', 'Bilgi', 'Hatırlatma'] } },
      ],
      sablon: {
        genislik: 520, yukseklik: 180, mod: 'serbest',
        arkaPlan: { tur: 'gradient', deger: 'linear-gradient(135deg, #faf3e0 0%, #f5e6c8 50%, #ebd5a8 100%)' },
        bolgeler: [],
        elementler: [
          { id: 'n0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 8, yukseklik: 180, stil: { fill: '#52c41a' } },
          { id: 'n1', tur: 'sabit-metin', icerik: '📌', x: 88, y: 2, genislik: 30, yukseklik: 30, stil: { fontSize: 18, textAlign: 'center' } },
          { id: 'n2', tur: 'sekil', sekilTuru: 'dikdortgen', x: 62, y: 6, genislik: 120, yukseklik: 24, stil: { fill: 'rgba(82,196,26,0.15)', borderRadius: 12 } },
          { id: 'n3', tur: 'parametre-render', parametreAnahtari: 'kategori', x: 62, y: 6, genislik: 120, yukseklik: 24, stil: { fontSize: 10, fontWeight: '600', color: '#389e0d', textAlign: 'center', verticalAlign: 'center', letterSpacing: 1 } },
          { id: 'n4', tur: 'parametre-metin', parametreAnahtari: 'baslik', x: 5, y: 22, genislik: 440, yukseklik: 50, stil: { fontSize: 22, fontWeight: '700', color: '#1a1a1a', verticalAlign: 'center' } },
          { id: 'n5', tur: 'sekil', sekilTuru: 'dikdortgen', x: 5, y: 58, genislik: 60, yukseklik: 2, stil: { fill: 'rgba(0,0,0,0.12)' } },
          { id: 'n6', tur: 'sabit-metin', icerik: '📋', x: 5, y: 68, genislik: 30, yukseklik: 30, stil: { fontSize: 16 } },
          { id: 'n7', tur: 'sabit-metin', icerik: 'HIZLI NOT', x: 12, y: 72, genislik: 100, yukseklik: 16, stil: { fontSize: 8, fontWeight: '700', color: 'rgba(0,0,0,0.2)', letterSpacing: 2, verticalAlign: 'center' } },
          { id: 'n8', tur: 'sekil', sekilTuru: 'dikdortgen', x: 92, y: 85, genislik: 40, yukseklik: 28, stil: { fill: 'rgba(0,0,0,0.04)', borderRadius: 2 } },
        ],
      } as ISablon,
    },
  ];

  icerikEkle(ek: any = null) {
    if (!ek) {
      ek = { turu: 'UYGULAMAICERIK', _id: '', parametreler: [] };
    }
    this.kart?.veri?.icerikler?.push({
      _id: new FikoYTId().toString(), aciklama: '', html: '', ek, sifre: null,
    }) ?? 0;
  }

  sifirla() {
    this.kart = {
      _id: new FikoYTId().toString(),
      vt: 'FikoYT.sistem.hareketler' as IVT,
      yol: 'FikoYT.sistem.hareketler.kalem' as IYollar,
      turu: IKartTuru.KART,
      gizlilik: 'Herkese Açık',
      kisiler: [],
      veri: {
        solSimge: { aciklama: undefined, baslik: 'HMI', renkArka: '#0ea5e9', renkYazi: '#fff' },
        kurdela: { aciklama: undefined, baslik: 'HMI', renkArka: undefined, renkYazi: undefined },
        icerikler: [],
      },
    };
    this.icerikEkle();
  }

  aktifEtSonSayfa() {
    this.aktifIcerikNo = (this.kart?.veri?.icerikler?.length ?? 1) - 1;
  }
}
